import React, { Component, Fragment } from "react";

import { connect } from "react-redux";

import styled from "styled-components";

import FullScreenDialog from "../FullScreenDialog";

import Filter from "../filter";
import Dialog from "../Dialog";
import Table from "../table";
import isMobile from "../../../store/reducers/isMobile";
import { audio } from "../../../utils/NotificationUtil";

import { Button } from "../../../design-system";
import { IconSparkles } from "../../../design-system/icons/icons";

const Card = styled.div`
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  box-shadow: var(--shadow-sm);
`;

const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  flex-wrap: wrap;
`;

const FilterWrapper = styled.div`
  flex: 1;
  min-width: 240px;
`;

const ToolbarActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
`;

const PlusIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);

type Props = {
  onCreateItem?: Function;
  onRemoveItem?: Function;
  onEditItem?: Function;
  Form: any;
  filterConfig: any;
  tabConfig?: Object[];
  canBeFiltered?: boolean;
  singularEntityName: string;
  pluralEntityName: string;
  withOwnTitle?: string;
  canBeRemoved?: boolean;
  canBeCreated?: boolean;
  canBeEdited?: boolean;
  onCloseForm?: Function;
  dataset: Array<any>;
  ExtraComponent?: any;
  ExtraDialog?: any;
  hideHeader?: boolean;
  hidePagination?: boolean;
};

type State = {
  isFullScreenDialogOpen: boolean;
  isRemoveDialogOpen: boolean;
  itemsFiltered: Array<any>;
  isExtraDialogOpen: boolean;
  contextItem: any;
  currentPage: number;
  rowsPerPage: number;
  formMode: string;
};

class EntityComponent extends Component<Props, State> {
  state = {
    isFullScreenDialogOpen: false,
    isRemoveDialogOpen: false,
    isExtraDialogOpen: false,
    itemsFiltered: [],
    contextItem: null,
    currentPage: 0,
    rowsPerPage: 0,
    formMode: "",
  };

  componentWillReceiveProps(nextProps) {
    const { formMode } = this.state;
    const { dataset } = nextProps;

    this.setState({
      itemsFiltered: dataset,
    });

    if (formMode === "edit") {
      const { itemsFiltered, contextItem } = this.state;

      const indexItemEditedOnItemsFiltered = itemsFiltered.findIndex(
        (itemFiltered) => itemFiltered.id === contextItem.id
      );

      const indexItemEditedOnOriginalDataset = dataset.findIndex(
        (item) => item.id === contextItem.id
      );

      const itemEdited = dataset[indexItemEditedOnOriginalDataset];

      this.setState({
        itemsFiltered: Object.assign([], itemsFiltered, {
          [indexItemEditedOnItemsFiltered]: itemEdited,
        }),
      });
    }
  }

  onToggleDialogRemove = (): void => {
    const { isRemoveDialogOpen } = this.state;

    this.setState({
      isRemoveDialogOpen: !isRemoveDialogOpen,
    });
  };

  onToggleExtraDialog = (): void => {
    const { isExtraDialogOpen } = this.state;

    this.setState({
      isExtraDialogOpen: !isExtraDialogOpen,
    });
  };

  onToggleFullScreenDialog = (): void => {
    const { isFullScreenDialogOpen } = this.state;

    this.setState({
      isFullScreenDialogOpen: !isFullScreenDialogOpen,
    });
  };

  onChageFormToEditMode = (): void => {
    this.setState({
      formMode: "edit",
    });
  };

  onTablePageChange = (newPage: number): void => {
    this.setState({
      currentPage: newPage,
    });
  };

  onFilterItems = (itemsFiltered: Array<Object>) => {
    this.setState({
      currentPage: 0,
      itemsFiltered,
    });
  };

  onClickCreateButton = (): void => {
    this.setState({
      isFullScreenDialogOpen: true,
      formMode: "create",
    });
  };

  onTableEditIconClicked = (item: Object): void => {
    this.setState({
      isFullScreenDialogOpen: true,
      contextItem: item,
      formMode: "edit",
    });
  };

  onTableDetailIconClicked = (item: Object, rowsPerPage: number): void => {
    if (!!audio) audio.pause();
    this.setState({
      isFullScreenDialogOpen: true,
      formMode: "detail",
      contextItem: item,
      rowsPerPage,
    });
  };

  onTableRemoveIconClicked = (item: Object, rowsPerPage: number): void => {
    this.setState({
      isRemoveDialogOpen: true,
      contextItem: item,
      rowsPerPage,
    });
  };

  onOpenExtraDialog = (item: Object): void => {
    this.setState({
      isExtraDialogOpen: true,
      contextItem: item,
    });
  };

  getCurrentPageAfterRemotion = (): number => {
    const { rowsPerPage, currentPage, itemsFiltered } = this.state;

    const maxPageReacheable =
      Math.ceil((itemsFiltered.length - 1) / rowsPerPage) - 1;

    if (itemsFiltered.length - 1 === 0) {
      return 0;
    }

    if (currentPage <= maxPageReacheable) {
      return currentPage;
    }

    return currentPage - 1;
  };

  createItem = (itemCreated: Object): void => {
    const { onCreateItem } = this.props;

    this.setState(
      {
        isFullScreenDialogOpen: false,
        currentPage: 0,
      },
      () => onCreateItem(itemCreated)
    );
  };

  editItem = (item: Object): void => {
    const { onEditItem } = this.props;
    const { contextItem } = this.state;

    const itemEdited = {
      ...contextItem,
      ...item,
    };

    this.setState(
      {
        isFullScreenDialogOpen: false,
      },
      () => onEditItem(itemEdited)
    );
  };

  removeItem = (): void => {
    const { itemsFiltered, contextItem } = this.state;
    const { onRemoveItem } = this.props;

    const itemsFilteredAfterRemotion = itemsFiltered.filter(
      (itemFiltered) => itemFiltered.id !== contextItem.id
    );

    const currentPage = this.getCurrentPageAfterRemotion();

    this.setState(
      {
        itemsFiltered: itemsFilteredAfterRemotion,
        isFullScreenDialogOpen: false,
        currentPage,
      },
      () => onRemoveItem(contextItem)
    );
  };

  renderForm = () => {
    const { isFullScreenDialogOpen, formMode, contextItem } = this.state;
    const { singularEntityName, Form, withOwnTitle, onCloseForm } = this.props;

    const mode = {
      detail: "Details of ",
      create: "New ",
      edit: "Edit ",
    };

    const isFormCreateMode = formMode === "create";
    const item = !isFormCreateMode ? contextItem : {};

    const ownTitle = !!withOwnTitle && withOwnTitle.toUpperCase();
    const defaultTitle = `${mode[formMode] || ""}${singularEntityName}`;
    const title = ownTitle || defaultTitle;

    return (
      !!Form && (
        <FullScreenDialog
          onClose={() => {
            this.onToggleFullScreenDialog();

            if (onCloseForm) onCloseForm(item);
          }}
          isOpen={isFullScreenDialogOpen}
          title={title}
        >
          <div style={isMobile && { marginLeft: -20 }}>
            <Form
              onToggleFullScreenDialog={this.onToggleFullScreenDialog}
              onChageFormToEditMode={this.onChageFormToEditMode}
              onRemoveItem={this.removeItem}
              onCreateItem={this.createItem}
              onEditItem={this.editItem}
              mode={formMode}
              item={item}
            />
          </div>
        </FullScreenDialog>
      )
    );
  };

  renderToolbar = (): React.ReactNode => {
    const {
      singularEntityName,
      canBeCreated,
      filterConfig,
      withOwnTitle,
      dataset,
      ExtraComponent,
    } = this.props;

    const actionButtonTitle = withOwnTitle || singularEntityName;

    return (
      <ToolbarRow>
        <FilterWrapper>
          <Filter
            onFilterData={this.onFilterItems}
            shouldFilterAfterSelectFilter
            filterConfig={filterConfig}
            dataset={dataset}
          />
        </FilterWrapper>
        <ToolbarActions>
          {ExtraComponent && (
            <ExtraComponent values={this.state.itemsFiltered} />
          )}
          {canBeCreated && (
            <Button
              variant="primary"
              size="md"
              iconLeft={<PlusIcon />}
              onClick={this.onClickCreateButton}
            >
              {actionButtonTitle}
            </Button>
          )}
        </ToolbarActions>
      </ToolbarRow>
    );
  };

  renderRemoveDialog = () => {
    const { isRemoveDialogOpen } = this.state;
    const { singularEntityName } = this.props;

    return (
      <Dialog
        description={`Si realizas esta acción, los datos de ${singularEntityName} serán perdidos, y no se podran recuperar de ninguna manera.`}
        title={`¿Estás seguro que deseas eliminar ${singularEntityName}?`}
        positiveAction={this.removeItem}
        negativeAction={this.onToggleDialogRemove}
        onCloseDialog={this.onToggleDialogRemove}
        isOpen={isRemoveDialogOpen}
        positiveText="SÌ"
        negativeText="NO"
      />
    );
  };

  renderExtraDialog = () => {
    const { isExtraDialogOpen, contextItem } = this.state;
    const { ExtraDialog } = this.props;
    if (!ExtraDialog) return;
    return (
      <ExtraDialog
        toggle={this.onToggleExtraDialog}
        isOpen={isExtraDialogOpen}
        item={contextItem}
      />
    );
  };

  renderTable = () => {
    const { canBeRemoved, canBeEdited, tabConfig, hidePagination } = this.props;
    const { itemsFiltered, currentPage } = this.state;

    return (
      <Table
        onDetailIconClicked={this.onTableDetailIconClicked}
        onRemoveIconClicked={this.onTableRemoveIconClicked}
        onExtraDialogOpen={this.onOpenExtraDialog}
        onEditIconClicked={this.onTableEditIconClicked}
        updatePageIndex={this.onTablePageChange}
        canBeRemoved={canBeRemoved}
        canBeEdited={canBeEdited}
        currentPage={currentPage}
        dataset={itemsFiltered}
        hidePagination={hidePagination}
        tabConfig={tabConfig}
      />
    );
  };

  render() {
    const { hideHeader } = this.props;

    return (
      <Card>
        {!hideHeader && this.renderToolbar()}
        {this.renderTable()}
        {this.renderForm()}
        {this.renderExtraDialog()}
        {this.renderRemoveDialog()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps, null)(EntityComponent);
